import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModal = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
  width: auto;

  @media only screen and (max-width: 768px) {
    width: 60%;
    left: 20%;
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 34em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonOk = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;

export const ContentAnswer = styled.div`
  p:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    text-align: initial;
    margin: 9px 0;
  }
  p:nth-child(2) {
    background: rgba(250, 250, 250, 1);
    border-radius: 3px;
    padding: 0.3em 1.5em;
    text-align: initial;
    display: flex;
    align-items: center;
    min-height: 61px;
  }
`;
